export default __webpack_public_path__ + "static/AllOffices-c06f4cd83052770cac55fd2dfe5a80a3.png";